(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lc-inquiry-context"] && !Shopify.designMode) return;
  try {
    function fillInquiryContext() {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('.lc-inquiry-context').forEach(context => {
      const piece = context.querySelector('[data-inquiry-piece]');
      const request = context.querySelector('[data-inquiry-request]');
      const product = context.querySelector('[data-inquiry-url]');
      if (!piece.value && params.has('piece')) piece.value = params.get('piece').slice(0,300);
      if (Array.from(request.options).some(option => option.value === params.get('request'))) request.value = params.get('request');
      const path = params.get('product') || '';
      if (path.startsWith('/products/') && !path.includes('://')) product.value = window.location.origin + path.slice(0,400);
    });
  }
  fillInquiryContext();
  document.addEventListener('shopify:section:load', fillInquiryContext);
  } catch(e) { console.error(e); }
})();

})();
